import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { AlbumCell, AlbumCellProps, SvgIcon } from '../../../Molecules';
import { SVGIconType } from '../../../../constants/svgIcon';

import './TryAlbumListTemplate.css';

export type TryAlbumListTemplateProps = {
  albumData: AlbumCellProps[];
};

export const TryAlbumListTemplate = memo(
  ({ albumData }: TryAlbumListTemplateProps) => {
    const { t } = useTranslation();

    return (
      <div className="try-album-list">
        <div className="centered-container">
          <div className="title-container">
            <div className="title-text">{t('Try AI Memory Games')}</div>
          </div>

          <div className="list-view">
            {albumData.length === 0 ? (
              <div className={'empty-container'}>
                <SvgIcon
                  name={SVGIconType.BrainX9}
                  className={'empty-album-icon'}
                />
                <div className="empty-album-text">{t('No Journeys Yet')}</div>
              </div>
            ) : (
              albumData.map((item, index) => (
                <AlbumCell key={index} {...item} />
              ))
            )}
          </div>
        </div>
      </div>
    );
  },
);
